import { Link } from "react-router-dom";
import { House } from "lucide-react";
import { scrollToId } from "../content";

const ACC = "#5D8FC4";

export const H2 = ({ children, id }) => (
  <h2 id={id} className="uppercase font-black tracking-tight text-2xl md:text-3xl pt-16 mt-4 border-t border-white/10 scroll-mt-28" style={{ color: ACC }}>
    {children}
  </h2>
);
export const H3 = ({ children }) => <h3 className="font-bold text-lg mt-10 text-[#EDF2F7]">{children}</h3>;
export const P = ({ children }) => <p className="mt-4 text-[15px] leading-[1.85] text-[#a8b3c0]">{children}</p>;
export const UL = ({ items }) => (
  <ul className="mt-4 space-y-2 list-disc pl-6 text-[15px] leading-[1.75] text-[#a8b3c0]">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);
export const Callout = ({ children, testId }) => (
  <div data-testid={testId} className="mt-6 border-l-4 pl-5 py-4 pr-5 bg-white/[0.04]" style={{ borderColor: ACC }}>
    <p className="text-[15px] leading-[1.8] text-[#dbe4ee]">{children}</p>
  </div>
);

export const ContactSection = () => (
  <>
    <H2 id="contact">Contact Us</H2>
    <div className="mt-6 border border-white/10 bg-white/[0.03] p-7 text-[15px] leading-[1.9] text-[#a8b3c0]" data-testid="legal-contact-card">
      <p className="font-bold text-[#EDF2F7]">Great Western Funding</p>
      <p>2906 Hermosa Ave, La Crescenta, CA 91214</p>
      <p>Attn: Oscar Tobar, President</p>
      <p>Phone: <a href="tel:+18182310061" className="hover:text-[#5D8FC4] transition-colors duration-200">(818) 231-0061</a></p>
      <p>Email: <a href="mailto:oscar@greatwesternfunding.com" className="hover:text-[#5D8FC4] transition-colors duration-200">oscar@greatwesternfunding.com</a></p>
      <p>Website: webinar.greatwesternfunding.com</p>
    </div>
  </>
);

export const LegalShell = ({ title, current, testId, children }) => (
  <div className="relative min-h-screen" data-testid={testId}>
    <nav className="sticky top-0 z-50 backdrop-blur-xl bg-[#070B11]/85 border-b border-white/10">
      <div className="max-w-[820px] mx-auto px-6 py-4 flex items-center justify-between gap-4 flex-wrap">
        <Link to="/" data-testid="legal-back-home-link" className="font-mono-c text-[11px] tracking-[0.2em] text-white/50 hover:text-[#5D8FC4] transition-colors duration-200">
          ← BACK TO SITE
        </Link>
        <div className="flex items-center gap-4 sm:gap-6">
          <Link
            to="/privacy-policy"
            data-testid="legal-nav-privacy"
            className={`font-mono-c text-[10px] sm:text-[11px] tracking-[0.15em] uppercase pb-0.5 border-b transition-colors duration-200 ${current === "privacy" ? "text-[#5D8FC4] border-[#5D8FC4]" : "text-white/60 border-transparent hover:text-[#5D8FC4]"}`}
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms-conditions"
            data-testid="legal-nav-terms"
            className={`font-mono-c text-[10px] sm:text-[11px] tracking-[0.15em] uppercase pb-0.5 border-b transition-colors duration-200 ${current === "terms" ? "text-[#5D8FC4] border-[#5D8FC4]" : "text-white/60 border-transparent hover:text-[#5D8FC4]"}`}
          >
            Terms & Conditions
          </Link>
          <button data-testid="legal-nav-contact" onClick={() => scrollToId("contact")} className="font-mono-c text-[10px] sm:text-[11px] tracking-[0.15em] uppercase text-white/60 hover:text-[#5D8FC4] border-b border-transparent hover:border-[#5D8FC4] pb-0.5 transition-colors duration-200">
            Contact
          </button>
        </div>
      </div>
    </nav>

    <div className="max-w-[820px] mx-auto px-6 pb-24">
      <header className="pt-16 pb-10">
        <p className="font-mono-c text-[11px] tracking-[0.35em] uppercase" style={{ color: ACC }}>Great Western Funding</p>
        <h1 className="mt-4 uppercase font-black tracking-[-0.02em] leading-[1.02] text-3xl md:text-5xl">{title}</h1>
        <p className="mt-5 text-white/55 text-[15px] leading-relaxed">Applies to webinar.greatwesternfunding.com and all related registration and messaging services.</p>
        <p className="mt-3 font-mono-c text-[12px] text-white/40">Effective Date: August 1, 2026</p>
      </header>
      {children}
      <ContactSection />
      <footer className="mt-16 pt-8 border-t border-white/10">
        <p className="flex items-center gap-2 font-mono-c text-[11px] text-white/35">
          <House className="w-4 h-4" strokeWidth={1.5} />
          © 2026 Great Western Funding. All rights reserved. | Equal Housing Lender
        </p>
        <p className="font-mono-c text-[10px] text-white/25 mt-2">Oscar Tobar NMLS# 667612 · Company NMLS# 2739318</p>
      </footer>
    </div>
  </div>
);
